module.exports = {
  dsn: process.env.SENTRY_DSN,
  release: process.env.COMMIT_REF || '',
  environment: `${(process.env.BRANCH || '').replace(/\//g, '--')} - ${
    process.env.NETLIFY ? 'netlify' : ``
  }${process.env.GATSBY_CLOUD ? 'gatsby cloud' : ``}`,
};
